import React from 'react';
import { Box, Stack } from '@mantine/core';
import { SidebarItem as SidebarItemComponent } from './SidebarItem';
import { SidebarItem, SidebarLink, DIVIDER } from './types';

interface SidebarProps {
  links: SidebarItem[];
  activeUrl: string;
}

export function Sidebar({ links, activeUrl }: SidebarProps) {
  return (
    <Box w={240} data-testid="sidebar">
      <Stack gap="xs">
        {links.map((item, index) => (
          <SidebarItemComponent
            key={item === DIVIDER ? `divider-${index}` : (item as SidebarLink).href}
            item={item}
            activeUrl={activeUrl}
          />
        ))}
      </Stack>
    </Box>
  );
}

